/**
 * Loads the Eliq insights graph.
 * This is more or less exactly what is included in their example,
 * we just don't add the next element here and instead use a more normal
 * react way of adding it.
 *
 * @param token A user auth token.
 * @returns
 */
export const loadEliqGraph = (token: string): boolean => {
  const container = document.getElementById('container');

  let eliqAuthElement = document.getElementById('eliqAuth');
  if (!eliqAuthElement) {
    eliqAuthElement = document.createElement('eliq-auth');
    eliqAuthElement.setAttribute('id', 'eliqAuth');
  }

  eliqAuthElement.setAttribute('access-token', token);
  // If there are issues later on with loading the element they might be fixed by adding
  // an event handler to this element and using that to create the eliq-insights element.
  container?.appendChild(eliqAuthElement);
  return true;
};
